<script setup lang="ts">
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { ref } from "vue";
import { gql } from "@apollo/client/core";
import { useMutation, useQuery, useResult } from "@vue/apollo-composable";
import CarSideIcon from "../components/icons/CarSideIcon.vue";
import { dateRelative } from "@/libs/filters";

const displayModeMobile = ref(false);

const { loading, error, result, onResult } = useQuery(
  gql`
    query myNotifications($after: String, $first: Int) {
      myNotifications(after: $after, first: $first) {
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          id
          broadcastMessageId
          userId
          wasViewed
          title
          body
          createdAt
        }
      }
    }
  `,
  {},
  {
    fetchPolicy: "network-only",
  }
);

const notifications = useResult(result, null, (data) => {
  return data.myNotifications;
});

const { mutate: markMyNotificationAsViewed } = useMutation(
  gql`
    mutation MarkMyNotificationsAsViewed {
      markMyNotificationsAsViewed
    }
  `,
  {
    fetchPolicy: "no-cache",
  }
);

onResult(() => {
  markMyNotificationAsViewed();
});
</script>

<template>
  <DefaultLayout>
    <article class="container framework-slot">
      <div class="row">
        <div class="col">
          <div class="main-content">
            <h5>Notificações</h5>
            <div class="notify">
              <ul v-if="loading">
                <li>
                  <div class="notifyBody">
                    <div class="notifyDescription">
                      Carregando suas notificações...
                    </div>
                  </div>
                </li>
              </ul>
              <ul v-else-if="notifications && notifications.nodes.length > 0">
                <li v-for="notification of notifications.nodes">
                  <div
                    v-if="!notification.wasViewed"
                    class="notifyIconBadge"
                  ></div>
                  <div class="notifyIcon">
                    <CarSideIcon />
                  </div>
                  <div class="notifyBody">
                    <div class="notifyTitle">{{ notification.title }}</div>
                    <div class="notifyDescription">{{ notification.body }}</div>
                    <div class="notifyTime">
                      {{ dateRelative(notification.createdAt) }}
                    </div>
                  </div>
                </li>
              </ul>
              <ul v-else>
                <li>
                  <div class="notifyBody">
                    <div class="notifyDescription">
                      No momento você não tem notificações.
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </article>
  </DefaultLayout>
</template>

<style scoped>
.notify {
  background-color: var(--dark-color);
  margin: 10px 0 20px;
  padding: 10px 15px;
  border-radius: 0.5rem;
  color: var(--white-ice);
  align-items: center;
}

h5 {
  margin-top: 20px;
  font-weight: 600;
  color: var(--primary-color);
}

.notify ul {
  padding: 0;
}

.notify ul li {
  position: relative;
  list-style-type: none;
  border-bottom: 1px solid var(--dark-grey);
  padding: 10px;
  display: flex;
  flex-direction: row;
}

.notify ul li:last-child {
  border: none;
}

.notifyIcon {
  margin-right: 15px;
  display: flex;
  padding: 5px 0 0 10px;
}

.notifyIcon svg {
  height: 36px;
  width: 36px;
  padding: 7px;
  border: 1px solid var(--dark-grey);
  background-color: var(--dark-grey);
  border-radius: 18px;
}

.notifyIconBadge {
  position: absolute;
  top: 30px;
  left: 5px;
  display: block;
  height: 6px;
  width: 6px;
  border-radius: 3px;
  background-color: var(--highlight-color);
}

.notifyBody {
  display: flex;
  flex-direction: column;
}

.notifyTitle {
  font-weight: 700;
  margin-bottom: 2px;
}

.notifyDescription {
  margin-bottom: 4px;
}

.notifyTime {
  font-size: 12px;
  margin-bottom: 3px;
  font-style: italic;
}

.footer {
  margin: 0 auto;
}
</style>
